import React from 'react';

import {withStyles} from "@material-ui/core";
import StyledAxlMultiSelect from "../../../../components/StyledAxlMultiSelect";

import * as Reports from "../../../ReportComponents/reportStyles";
import { styles } from "./styles";

function BrandMultiSelect({ handleOnChange, name, clientProfileOptions, profiles }) {

  const handleChangeProfiles = (profiles) => {
    const options = profiles?.length < 1 ? clientProfileOptions : profiles;
    handleOnChange(name, options?.map(r => r.value));        
  }

  return (
    <Reports.GroupField style={{textAlign: 'left'}}>
      <Reports.Label>{`for`}</Reports.Label>
      <StyledAxlMultiSelect
        defaulValue={clientProfileOptions?.length === profiles?.length ? [] : clientProfileOptions.filter(option => profiles?.includes(option.value))}
        placeholderButtonLabel="all brands"
        showValues={false}
        allowAll={true}
        onChange={handleChangeProfiles}
        placeholder="Search brands…"
        options={clientProfileOptions}
      />
    </Reports.GroupField>
  )  
}

export default withStyles(styles)(BrandMultiSelect);